module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-container",
    domProps: {
      "innerHTML": _vm._s(_vm.series)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67bb12a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/RawWidget.vue
// module id = 678
// module chunks = 0